export default (theme) => ({
	heading: {
		width: '60%',
		fontSize: theme.typography.pxToRem(20),
		fontWeight: 'bold',
		color: '#fff',
		paddingTop: 10,
		// paddingLeft: 30,
		paddingLeft: 12,
		backgroundColor: 'transparent',
		borderWidth: 0,
		'&:focus': {
			outline: 'none',
		},
	},
	headingExpanded: { paddingTop: 22 },
	expansionPanelRoot: {
		backgroundColor: 'transparent',
		boxShadow: 'none',
		'&:before': { height: 0 },
	},
	expansionPanelExpanded: {
		margin: '12px 0 !important',
	},
	summaryRoot: { padding: 0 },
	summaryExpanded: { margin: '0 !important', height: 64 },
	content: { margin: 0, flexGrow: 0, width: '100%' },
	numberIcon: {
		position: 'absolute',
		left: 0,
		borderRadius: '50%',
		width: 30,
		height: 30,
		color: '#fff',
		textAlign: 'center',
		paddingTop: 8,
		fontSize: 12,
		fontWeight: 'bold',
	},
	numberIconExpanded: { top: '30%' },
	numberIconCollapsed: { top: '25%' },
	background: { margin: '0 auto', height: 48, position: 'relative' },
	backgroundColorMore: { backgroundColor: theme.palette.green },
	backgroundColor0: { backgroundColor: theme.palette.secondary.main },
	backgroundColor1: { backgroundColor: theme.palette.pink },
	backgroundColor2: { backgroundColor: theme.palette.orange },
	backgroundColor3: { backgroundColor: theme.palette.green },
	backgroundWidthMore: { width: '70%' },
	backgroundWidth0: { width: '100%' },
	backgroundWidth1: { width: '90%' },
	backgroundWidth2: { width: '80%' },
	backgroundWidth3: { width: '70%' },
	backgroundExpanded: {
		borderTopLeftRadius: 35,
		borderTopRightRadius: 35,
		width: '100%',
		height: '100%',
	},
	backgroundCollapsed: { borderRadius: 35 },
	expandIconMore: { right: '15%' },
	expandIcon0: { right: 0 },
	expandIcon1: { right: '5%' },
	expandIcon2: { right: '10%' },
	expandIcon3: { right: '15%' },
	expandIconExpanded: { right: 0 },
	// detailsRoot: { padding: '0 0 0 48px' },
	detailsRoot: { padding: 0 },
	menuItem: {
		'&:focus': {
			backgroundColor: theme.palette.primary.main,
			'& $primary, & $icon': {
				color: theme.palette.common.white,
			},
		},
	},
	primary: {},
	icon: {},
	listItemTextRoot: { padding: 0 },
	buttonAdd: {
		height: 48,
		borderRadius: 35,
		paddingTop: 6,
		textAlign: 'center',
		margin: 'auto',
		[theme.breakpoints.down('xs')]: {
			paddingTop: 9,
		},
	},
	buttonAddTypography: {
		fontSize: 20,
		fontWeight: 'bold',
		[theme.breakpoints.down('xs')]: {
			fontSize: 16,
		},
	},
})
